import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Typography from "@mui/material/Typography";
import { useMerchant } from "../../../../store/global/useMerchant";
import { useCallback, useEffect, useRef, useState } from "react";
import { dateFormat, formatMoney } from "../../../../services/functions";
import { findCustomerCashback } from "../../../../services/models/cashback";
import { usePrinter } from "../../../../store/schedule/usePrinter";

export function AccordionCashback(props) {
  const cpf = props.cpf || props.customer?.cpf;
  const [cashback, setCashback] = useState(null);
  const requestId = useRef(0);
  const merchant = useMerchant((state) => state.data.merchant);

  const getCashback = useCallback(async () => {
    if (!cpf || !merchant?.id) return;

    const currentRequestId = requestId.current + 1;
    requestId.current = currentRequestId;
    setCashback(null);
    usePrinter.getState().actions.setCustomer({ cashback: null });

    try {
      const customerCashback = await findCustomerCashback({
        cpf,
        storeId: merchant.id,
      });

      if (requestId.current !== currentRequestId) return;

      usePrinter.getState().actions.setCustomer({ cashback: customerCashback });
      setCashback(customerCashback);
    } catch {
      if (requestId.current !== currentRequestId) return;

      usePrinter.getState().actions.setCustomer({ cashback: null });
      setCashback(null);
    }
  }, [cpf, merchant?.id]);

  useEffect(() => {
    getCashback();

    return () => {
      requestId.current += 1;
    };
  }, [getCashback]);

  if (!cashback || !cashback.status) return null;

  return (
    <Accordion className='px-3'>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel2a-content"
        id="panel2a-header"
      >
        <Typography>Cashback: <strong>R$ {formatMoney(cashback?.total_bonus)}</strong></Typography>
      </AccordionSummary>
      <AccordionDetails>
        <ul className="flex flex-col w-full">
          {(cashback?.bonus_list ?? []).map((item) => (
            <li key={item.expiration_on} className="flex w-full items-end gap-3 border-b-2 border-zinc-100 px-2 py-4 first:pt-0 last:border-none">
              <div className="flex flex-col w-full flex-1">
                <span><strong>Validade: </strong>{dateFormat(item?.expiration_on)}</span>
                <span><strong>Compra mínima: </strong>R$ {formatMoney(item?.balance * 2)}</span>
              </div>
              <span><strong>R$ {formatMoney(item?.balance)}</strong></span>
            </li>
          ))}

        </ul>
      </AccordionDetails>
    </Accordion>

  );
}
